import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@iconify/react";

export default function RecordNotFound({
  title,
  description,
  icon = "solar:inbox-bold-duotone",
  actionLabel,
  onAction,
  compact = false,
  className = "",
}) {
  const rootClass = [
    "no-access-string",
    "record-empty-state",
    compact && "record-empty-state--compact",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClass} role="status" aria-live="polite">
      <div className="record-empty-state__frame">
        <div className="record-empty-state__glow" aria-hidden />
        <div className="record-empty-state__icon-wrap">
          <Icon icon={icon} className="record-empty-state__icon" aria-hidden />
        </div>
      </div>
      <h3 className="record-empty-state__title">{title}</h3>
      {description ? (
        <div className="record-empty-state__desc">{description}</div>
      ) : null}
      {actionLabel && typeof onAction === "function" ? (
        <button type="button" className="record-empty-state__action" onClick={onAction}>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}

RecordNotFound.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  icon: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  compact: PropTypes.bool,
  className: PropTypes.string,
};
